import { Flex, Icon, Text, Avatar } from "@chakra-ui/react";
import { FaUber } from "react-icons/fa";
import { Link } from "react-router-dom";
import { BLUEMONEDD, VARIANT, WHITE } from "../constants/colors";

function CardMenu(props: any) {
  return (
    <>
      <Link to={props.path}>
        <Flex
          _hover={{ bg: "#f2f2f2", borderColor: "black", borderWidth: "2px" }}
          bgColor={WHITE}
          borderRadius={"5px"}
          mb={"5"}
          textDecoration={"none"}
          w={"15vw"}
          alignItems={"center"}
          justifyContent={"flex-start"}
          shadow={"md"}
          flexDirection={"row"}
          h="80px"
          color={props.color}
          cursor="pointer"
          px={6}
          py={5}
          mx={1.5}
          transition="all .2s ease-in-out"
          borderWidth={"1px"}
          borderColor={props.color}
        >
          <Avatar bgColor={props.color} icon={props.icon} color={"white"} />
          <Flex flexDirection={"column"} justifyContent={"flex-start"}>
            <Text ml={6} fontSize={16}>
              {props.text}
            </Text>
            <Text ml={6} color={"gray"} fontSize={11}>
              {props.description}
            </Text>
          </Flex>
        </Flex>
      </Link>
    </>
  );
}
export default CardMenu;
